module.exports = __webpack_public_path__ + "img/messina_hero_bg.e1ccbeaf.png";